import infrared from './dapps/infrared';
import berps from './dapps/berps';
import aquabera from './dapps/aquabera';
import bedrock from './dapps/bedrock';
import berapaw from './dapps/berapaw';

export default {
  infrared,
  berps,
  aquabera,
  bedrock,
  berapaw,
} as Record<string, any>;
